import React from 'react';
import UapiSurface from './shared/UapiSurface';
import './OhipTransactionsPage.css';
import './UniversalApiPage.css';

// Admin > Platform > Universal API — the DEFINITION of the API.
//
// The first half of separating two jobs that shared one screen:
//
//   here                     what the Universal API IS — its routes and the operations under them.
//                            One artefact, the same for every property.
//   Legacy > Universal API   provisioning a PROPERTY's authentication against it — which credential a
//                            caller presents, which system it routes to, the per-hotel values.
//
// They were together because the screen was written before the distinction mattered, and the result
// read badly in one specific way: adding a route from a page scoped to a hotel looks like a hotel
// setting, when it changes the API for everyone. Filed under Platform for the same reason the Vault
// System and Canonical screens are — it is configuration of the product, not of a customer.
//
// No hotel context is read here deliberately. If this page needed one it would be the wrong page.
function UniversalApiDefinitionPage() {
    return (
        <div className="otx-page">
            <div className="otx-header">
                <div>
                    <h1>Universal API</h1>
                    <p className="otx-subtitle">
                        The API surface — routes and the operations under them. This defines the API for
                        every property; a hotel's credentials for calling it are provisioned under
                        Legacy &rsaquo; Universal API.
                    </p>
                </div>
            </div>

            <UapiSurface />
        </div>
    );
}

export default UniversalApiDefinitionPage;
